
/**
 * 통화 코드
 */
export type CourseDraftUpdatePriceCurrency = typeof CourseDraftUpdatePriceCurrency[keyof typeof CourseDraftUpdatePriceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftUpdatePriceCurrency = {
  KRW: 'KRW',
  USD: 'USD',
  EUR: 'EUR',
} as const;
